import React from 'react';
import UploadFileComponent from './UploadFileComponent';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class NewArticleComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            name: '',
            description: '',
            currency: '',
            price: '',
            linkUrl: '',
            categoryId: '',
            brandId: '',
            hasPromo: false,
            videoCover: undefined,
            isValid: false,
            brands: TotemActions.getBrands(),
            categories: TotemActions.getCategories()
        };
    }

    componentWillMount() {
        TotemStore.on('BRANDS_RECEIVED', this._onReceiveBrands.bind(this));
        TotemStore.on('CATEGORIES_RECEIVED', this._onReceiveCategories.bind(this));
    }

    _onReceiveBrands() {
        this.setState({
            brands: TotemStore.getBrands()
        });
    }
    _onReceiveCategories() {
        this.setState({
            categories: TotemStore.getCategories()
        });
    }

    _handleCreateArticle() {
        let { name, description, linkUrl, price, currency, categoryId, brandId } = this.state;
        this.setState({
            loading: true
        });
        description = description.replace(/(?:\r\n|\r|\n)/g, '<br />');
        TotemActions.addItem(name, description, linkUrl, price, currency, categoryId, brandId, hasPromo, this.newArticleCallback.bind(this));
    }

    newArticleCallback() {
        this.setState({
            loading: false
        });
        this.props.articleSaved();
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            isValid: (this.state.name !== '' && this.state.description !== '' && this.state.currency !== '' && this.state.price !== '' && this.state.linkUrl !== '' && this.state.categoryId !== '' && this.state.brandId !== '')
        });
    }

    _handleSetCoverType(value) {
        this.setState({
            videoCover: value
        });
    }

    _onCancelModal() {
        this.setState({
            name: '',
            description: '',
            currency: '',
            price: '',
            linkUrl: '',
            categoryId: '',
            brandId: '',
            hasPromo: false,
            videoCover: true,
            isValid: false
        });
        this.props.cancelModal()
    }

    render() {

        let { brands } = this.state;
        let { categories } = this.state;

        let brandOptions = [];
        let categoriesOptions = [];

        if (brands) {
            brandOptions = brands.map((brand) => {
                let key = new Date().getUTCMilliseconds() * brand.id;
                return <option value={brand.id} key={key}>{brand.name}</option>
            });
        }

        if (categories) {
            categoriesOptions = categories.map((category) => {
                let key = new Date().getUTCMilliseconds() * category.id;
                return <option value={category.id} key={key}>{category.name}</option>
            });
        }

        return (
            <div id="createArticle" className="modal modal-fixed-footer">
                <div className="modal-content">
                    <h5>Agregar nuevo artículo</h5>
                    <div className="row">
                        <div className="input-field col s4">
                            <input type="text" name="name" value={this.state.name} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="name">Nombre</label>
                        </div>
                        <div className="input-field col s4">
                            <select className="browser-default" name="categoryId" value={this.state.categoryId} onChange={this._handleInputChange.bind(this)}>
                                <option value="" disabled>Categoría</option>
                                {categoriesOptions}
                            </select>
                        </div>
                        <div className="input-field col s4">
                            <select className="browser-default" name="brandId" value={this.state.brandId} onChange={this._handleInputChange.bind(this)}>
                                <option value="" disabled>Sucursales</option>
                                {brandOptions}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s4">
                            <select className="browser-default" name="currency" value={this.state.currency} onChange={this._handleInputChange.bind(this)}>
                                <option value="" disabled>Tipo de moneda</option>
                                <option value="USD">USD</option>
                                <option value="ARS">ARS</option>
                            </select>
                        </div>
                        <div className="input-field col s4">
                            <input type="number" name="price" value={this.state.price} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="price">Precio</label>
                        </div>
                        <div className="input-field col s4">
                            <input type="checkbox" name="hasPromo" id="hasPromo" checked={this.state.hasPromo} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="hasPromo">Promoción</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input type="text" name="linkUrl" value={this.state.linkUrl} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="linkUrl">Link de compra</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <textarea id="textarea1"  name="description" value={this.state.description} onChange={this._handleInputChange.bind(this)} rows="4" className="materialize-textarea"></textarea>
                            <label htmlFor="description">Descripción del artículo</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s12">
                            <label>Fotos</label>
                        </div>
                        <div className="uploads-container col s12">
                            <div className="col s4">
                                <UploadFileComponent />
                            </div>
                            <div className="col s4">
                                <UploadFileComponent />
                            </div>
                            <div className="col s4">
                                <UploadFileComponent />
                            </div>
                            <div className="col s4">
                                <UploadFileComponent />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s12">
                            <span>Seleccione entre subir un <a onClick={this._handleSetCoverType.bind(this, true)}>video</a> o una <a onClick={this._handleSetCoverType.bind(this, false)}>foto</a> para ser usada como portada del nuevo artículo</span>
                        </div>
                        {this.state.videoCover ?
                            <div className="uploads-container col s12">
                                <div className="col s12">
                                    <UploadFileComponent type="cover" text="Subir un video como portada" video={true} />
                                </div>
                            </div>
                            :
                            <div className="uploads-container col s12">
                                <div className="col s12">
                                    <UploadFileComponent type="cover" cover="photo" text="Subir una foto como portada" />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="modal-footer right-align">
                    <a className="waves-effect waves-light btn  red darken-4" onClick={this._onCancelModal.bind(this)}>Cancelar</a>
                    <a className={this.state.isValid ? 'waves-effect waves-light btn blue darken-3' : 'waves-effect waves-light btn blue darken-3 disabled'} onClick={this._handleCreateArticle.bind(this)}>Guardar artículo</a>
                </div>
            </div>
        );
    }
}

export default NewArticleComponent;


// WEBPACK FOOTER //
// ./src/components/NewArticleComponent.js